module.exports = __webpack_public_path__ + "02_glasses_black.6b3f8c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/02_glasses_black.png
// module id = zhpq
// module chunks = 0